import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';

function ThankYou() {
  return (
    <Container>
      <h1>Thank you for joining Lehumo</h1>
      <h3>Now you can sign in to your account</h3>

      <Link to="/Login"><button>Sign in</button></Link>
    </Container >
  )
}

export default ThankYou

const Container = styled.div`
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    h1 {
        padding-top: 30px;
        text-transform: uppercase;
        font-size: 38px;
    }

    h3 {
        text-transform: uppercase;
        padding-bottom: 20px;

        @media (max-width: 821px) {
            font-size: 16px;
        }
    }

    button {
      width: 200px;
      height: 50px;
      background-color: transparent;
      color: var(--primary);
      border: 2px solid var(--primary);
      text-transform: uppercase;
      font-weight: 600;


      :hover {
        background-color: var(--primary);
        color: #fff;
        transition: 0.2s ease-in;
      }
    }
`
